/* Константы для отключений */

import { IRequest } from 'types';

// Статусы, отображаемые в отчёте по заявкам (requestsReportStore -> createExcelReport).
// Намеренно не включает 'hidden' в отличие от IRequestStatus - скрытые заявки
// в отчёт не попадают.
export const REPORT_STATUSES = [
  'performed',
  'accepted',
  'delayed',
  'abandonment',
  'refusal',
  'run',
] as const;

export type ReportStatus = (typeof REPORT_STATUSES)[number];

export const REQUEST_TAGS = [
  'urgent',
  'current',
  'planned',
  'acceptance',
  'prophylaxis',
] as const;

export const BlackoutActions = [
  {
    value: 'cold_water_supply',
    name: 'Отключение ХВС',
    categories: ['emergency', 'commercial'],
    subcategories: ['leak', 'chargeable', 'warranty'],
  },
  {
    value: 'hot_water_supply',
    name: 'Отключение ГВС',
    categories: ['emergency', 'commercial'],
    subcategories: ['leak', 'chargeable', 'warranty'],
  },
  {
    value: 'central_heating',
    name: 'Отключение ЦО',
    categories: ['emergency', 'commercial'],
    subcategories: ['leak', 'chargeable', 'warranty'],
  },
  {
    value: 'lift',
    name: 'Отключение лифта',
    categories: ['emergency'],
    subcategories: ['lift'],
  },
  {
    value: 'electricity',
    name: 'Отключение электроснабжения',
    categories: ['emergency'],
    subcategories: ['electricity'],
  },
];

type RequesterType = IRequest['requester']['_type'];

export const REQUESTER_TYPES: { value: RequesterType; text: string }[] = [
  { value: 'tenant', text: 'Жилец' },
  { value: 'other_person', text: 'Стороннее лицо' },
  { value: 'employee', text: 'Сотрудник' },
  { value: 'other_employee', text: 'Представитель организации' },
];
